import { Component, Inject, OnInit, Optional } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { forkJoin } from "rxjs";
import { finalize } from "rxjs/operators";
import { ToastService } from "../core";
import { ConfigurationApi, DocumentTypes, LookupApi, OfficeEntity } from "../core/api.gen";
import { CommonService } from "../core/common.service";
import { DialogService } from "../core/dialog.service";
import { LoaderService } from "../core/loader.service";
import { LookupTypeKeys } from "../shared/lookup-type-keys";


@Component({
  selector: 'eos-governance-newdoc-types',
  templateUrl: './governance-newdoc-types.component.html',
  styleUrl: './governance-newdoc-types.component.css'
})
export class GovernanceNewdocTypesComponent implements OnInit {

  countries = [];
  officeLocations = [];
  officeLegalEntities: OfficeEntity[] = [];
  allDocumentTypes: DocumentTypes[] = [];
  documentTypes: DocumentTypes[] = [];

  filterForm = new UntypedFormGroup({
    documentTypeId: new UntypedFormControl(null),
  });

  private baseUrl: string;

  constructor(
    private common: CommonService,
    private lookupApi: LookupApi,
    private configApi: ConfigurationApi,
    private loader: LoaderService,
    private dialogService: DialogService,
    private toast: ToastService,
  ) {}

  ngOnInit() {
    this.loader.show();
    forkJoin({
      countries: this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.OFFICE_LOCATION_COUNTRY]),
      officeLocations: this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.OFFICE_LOCATION]),
      officeLegalEntities: this.lookupApi.getOfficeEntities(undefined, undefined),
      documentTypes: this.configApi.getDocumentTypes(),
    })
    .pipe(finalize(() => this.loader.clear()))
    .subscribe((p) => {
      this.countries = p.countries.filter(i =>
        [1048, 1047, 1052, 1049, 1050, 1051, 1055, 1053, 13410].includes(i.id)
      );
      this.officeLocations = p.officeLocations;
      this.officeLegalEntities = p.officeLegalEntities;
      this.allDocumentTypes = p.documentTypes;
      this.applyFilter();
    });
  }

  applyFilter() {
    const documentTypeId = this.filterForm.value.documentTypeId;
    this.documentTypes = documentTypeId
      ? this.allDocumentTypes.filter(d => d.id === documentTypeId)
      : this.allDocumentTypes;
  }

  clearFilter() {
    this.filterForm.reset();
    this.documentTypes = this.allDocumentTypes;
  }

  createDocumentType() {
    this.dialogService
      .showGovernanceNewDocTypeEdit(undefined, false, this.allDocumentTypes)
      .result.then((result) => {
        if (result === "success") this.ngOnInit();
      });
  }

  editDocumentType(doc: DocumentTypes) {
    this.dialogService
      .showGovernanceNewDocTypeEdit(doc, true, this.allDocumentTypes)
      .result.then((result) => {
        if (result === "success") this.ngOnInit();
      });
  }
}